import { useAuthenticatedUser } from './useAuthenticatedUser';

export function useHasPermission(permission: string): boolean {
  const user = useAuthenticatedUser();

  return user.hasPermission(permission);
}

export default useHasPermission;
